module.exports = __webpack_public_path__ + "static/media/driving-miles.90e942d7.svg";